module.exports = __webpack_public_path__ + "static/media/objects_17.e7534205.svg";